export const useShare = () => ({ onShare: () => {} })
